import { Fragment, useEffect, useId, useState } from 'react';
import { DisciplineSection } from '../../../components/DisciplinesSection';
import { practiceConfigStore } from '../../../stores/practiceConfigStore';
import { auxiliarStore } from '../../../stores/auxiliarStore';
import { SectionContainer } from '../../../components/SectionContainer';
import { useMyRegularCourses } from '../../../../Courses/hooks/useRegularCourse'; //TODO: Ver sobre passar isso para o core (Melhoria)
import { useCoursesStore } from '../../../../Courses/stores/courseStore';
import { Typography } from '../../../../../core/components/molecules/Typography';
import { Select, iOption } from '../../../../../core/components/atoms/Select';
import CustomRadio from '../../../components/LabelFlexRadio';
import { useGetPracticeAreas } from '../../../hooks/getPracticeAreas';
import { Input } from '../../../../../core/components/atoms/Input';

const DO_NOT_SHOW_WEEK_SELECT = ['curso-fuvest-26'];

export function ContentSection() {
  useMyRegularCourses();
  useGetPracticeAreas();

  const { userMatriculatedCourse } = useCoursesStore();
  const {
    title,
    setAreasFilter,
    setTitle,
    setCourseId,
    setCourseWeekId,
    setQuestionsOrigin,
    questionsOrigin,
  } = practiceConfigStore();
  const { areas } = auxiliarStore();

  const [courseWeek, setCourseWeek] = useState<iOption>();
  const [weekSelect, setWeekSelect] = useState<iOption[]>();

  useEffect(() => {
    if (questionsOrigin && areas) {
      switch (questionsOrigin) {
        case 'all': {
          const newArray = areas.areas.map((it) => {
            return {
              area: it.id,
            };
          });

          setCourseId('');
          setCourseWeekId('');
          setAreasFilter(newArray);
          break;
        }
        case 'specific': {
          setCourseId('');
          setCourseWeekId('');
          setAreasFilter([{ area: '', subareas: [], subjects: [] }]);
          break;
        }
        case 'all-course': {
          setAreasFilter([]);
          setCourseWeekId('');
          setCourseId(userMatriculatedCourse.id);
          break;
        }
        case 'course-week': {
          setAreasFilter([]);
          setCourseWeekId('');
          setCourseId(userMatriculatedCourse.id);
          break;
        }
        default: {
          const newArray = areas.areas.map((it) => {
            return {
              area: it.id,
            };
          });

          setCourseId('');
          setCourseWeekId('');
          setAreasFilter(newArray);
          break;
        }
      }
    }
  }, [questionsOrigin, areas]);

  useEffect(() => {
    if (userMatriculatedCourse) {
      const weeks = userMatriculatedCourse.weeks;
      const selectArray = weeks.map((it: any) => ({
        value: it._id,
        label: it.title,
      }));

      setWeekSelect(selectArray);
    }
  }, [userMatriculatedCourse]);

  useEffect(() => {
    if (courseWeek && questionsOrigin === 'course-week') {
      setCourseWeekId(courseWeek.value.toString());
    }
  }, [courseWeek]);
  const titleInputId = useId();

  const shouldShowWeekSelect =
    userMatriculatedCourse &&
    !DO_NOT_SHOW_WEEK_SELECT.includes(userMatriculatedCourse?.slug || '');

  return (
    <>
      <Input
        id={titleInputId}
        label='Nome do simulado'
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        aria-describedby={`${titleInputId}-desc`}
      />
      <SectionContainer title='Conteúdos do simulado'>
        {shouldShowWeekSelect && (
          <Fragment>
            <CustomRadio
              value='all-course'
              checked={questionsOrigin}
              setData={(value) => setQuestionsOrigin(value)}
            >
              <Typography>
                Todo o conteúdo do curso {userMatriculatedCourse.title} até o
                momento
              </Typography>
            </CustomRadio>
            <CustomRadio
              value='course-week'
              checked={questionsOrigin}
              setData={(value) => setQuestionsOrigin(value)}
            >
              <div className='flex w-full gap-sm xs:flex-col xs:items-start lg:flex-row lg:items-center'>
                <Typography>Apenas o conteúdo da</Typography>
                <Select
                  options={weekSelect || []}
                  label='Semana'
                  onChange={(value) => setCourseWeek(value)}
                  value={courseWeek}
                  className='xs:w-full lg:w-1/5'
                  disabled={questionsOrigin !== 'course-week'}
                />
                <Typography>do curso {userMatriculatedCourse.title}</Typography>
              </div>
            </CustomRadio>
          </Fragment>
        )}
        <CustomRadio
          value='all'
          helper='Nesse modo, serão selecionados assuntos aleatórios de cada disciplina.'
          checked={questionsOrigin}
          setData={(value) => setQuestionsOrigin(value)}
        >
          <Typography>Todas as disciplinas</Typography>
        </CustomRadio>
        <CustomRadio
          value='specific'
          checked={questionsOrigin}
          setData={(value) => setQuestionsOrigin(value)}
        >
          <Typography>
            Quero especificar as disciplinas e os assuntos do simulado
          </Typography>
        </CustomRadio>
        {questionsOrigin === 'specific' && <DisciplineSection />}
      </SectionContainer>
    </>
  );
}
